import React from 'react';
import { FiTrash2 } from "react-icons/fi";
import { IoIosArrowDown } from "react-icons/io";

const CategoryDropdown2 = ({
    index,
    subIndex,
    dropdownOpen,
    handleSelect,
    handleRemove,
    selectedCategories,
    toggleDropdown,
    selectCategoryData,
    setSelectedCategories,
    subCategoryName // <-- You'll need to pass this from parent (selectedDetailed[index]?.subCategories[subIndex]?.name)
}) => {

    const isOpen = dropdownOpen[index]?.[subIndex] || false;

    // ✅ Find the correct subcategory entry by name
    const currentWrapper = selectedCategories?.find(
        (item) => item.subcategory === subCategoryName
    );

    const currentCategories = Array.isArray(currentWrapper?.individuals)
        ? currentWrapper.individuals
        : [];

    const handleInputChange = (value, categoryName) => {
        setSelectedCategories((prev) => {
            const updated = [...prev];

            const target = updated.find((item) => item.subcategory === subCategoryName);
            if (!target) return updated;

            const individual = target.individuals?.find((c) => c.category === categoryName);
            if (individual) individual.inputValue = value;

            return updated;
        });
    };

    return (
        <>
            {currentCategories.map((cat, idx) => (
                <div key={idx} className="selected-category">
                    <p>{cat.category}</p>
                    <div className='selected-category-details'>
                        <input
                            className='selectedCategoryText'
                            type="text"
                            value={cat.inputValue || ""}
                            onChange={(e) => handleInputChange(e.target.value, cat.category)}
                            placeholder="Add extra info"
                        />
                        <FiTrash2

                            size={18}
                            onClick={() => handleRemove(index, subIndex, cat.category)}
                            style={{ cursor: 'pointer', marginLeft: '8px' }}
                        />
                    </div>
                </div>
            ))}

            {selectCategoryData?.some(cat => !currentCategories.some(selected => selected.category === cat.name)) && (
                <div className='category-dropdown category'>
                    <div className='category-drop-down-head' onClick={() => toggleDropdown(index, subIndex)}>
                        <p>Select Category</p>
                        <IoIosArrowDown size={15} />
                    </div>
                    <div className={`categor-drop-down-items category ${isOpen ? 'show-drop-down-items' : ''}`}>
                        {selectCategoryData
                            ?.filter(cat => !currentCategories.some(selected => selected.category === cat.name))
                            ?.map((cat) => (
                                <p key={cat.name} onClick={() => handleSelect(index, subIndex, cat)}>
                                    {cat.name}
                                </p>
                            ))}
                    </div>
                </div>
            )}

        </>
    );
};


export default CategoryDropdown2;
